import { render, staticRenderFns } from "./PDFNavigator.vue?vue&type=template&id=0f5a8b30"
import script from "./PDFNavigator.vue?vue&type=script&lang=js"
export * from "./PDFNavigator.vue?vue&type=script&lang=js"
import style0 from "./PDFNavigator.vue?vue&type=style&index=0&id=0f5a8b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports